import React, { useState } from 'react';
import api from '../api';
import { useTranslation } from '../LanguageContext';

const ContactUs = () => {
    const { t } = useTranslation();
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState([]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setSuccess([]);
        try {
            const res = await api.post("/api/contact_us/", { message, subject, name, email });
            if (res.status === 200) {
                setMessage("");
                setSubject("");
                setSuccess([t('contact.successMsg')]);
            }
        }
        catch (error) {
            setErrors([error.response.data]);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-primary-50 flex items-center justify-center px-4 py-12">
            <div className="w-full max-w-lg">
                {/* Header */}
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-slate-800 mb-3">{t('contact.title')}</h1>
                    <p className="text-slate-500">
                        {t('contact.desc')}
                    </p>
                </div>

                {/* Form Card */}
                <div className="card">
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label htmlFor="name" className="label">{t('contact.nameLabel')}</label>
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                className="input"
                                id="name"
                                placeholder={t('contact.namePlaceholder')}
                                required
                                maxLength={100}
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="label">{t('contact.emailLabel')}</label>
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                maxLength={254}
                                type="email"
                                className="input"
                                id="email"
                                placeholder={t('contact.emailPlaceholder')}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="subject" className="label">{t('contact.subjectLabel')}</label>
                            <input
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                maxLength={100}
                                type="text"
                                className="input"
                                id="subject"
                                placeholder={t('contact.subjectPlaceholder')}
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className="label">{t('contact.messageLabel')}</label>
                            <textarea
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                maxLength={1000}
                                className="input min-h-[140px] resize-y"
                                id="message"
                                rows="5"
                                placeholder={t('contact.messagePlaceholder')}
                                required
                            ></textarea>
                        </div>

                        <button type="submit" className="btn-primary w-full">
                            {t('contact.sendBtn')}
                        </button>

                        {errors.length > 0 && (
                            <ul className="list-none p-0 space-y-1">
                                {errors.map((error, index) => (
                                    <li key={index} className="text-sm text-red-600">{` ${error}`}</li>
                                ))}
                            </ul>
                        )}
                        {success.length > 0 && (
                            <ul className="list-none p-0 space-y-1">
                                {success.map((msg, index) => (
                                    <li key={index} className="text-sm text-emerald-600">{` ${msg}`}</li>
                                ))}
                            </ul>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};
export default ContactUs;
